/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ResponseStyleType,
    ResponseStyleTypeFromJSON,
    ResponseStyleTypeFromJSONTyped,
    ResponseStyleTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ResponseOptions
 */
export interface ResponseOptions {
    /**
     * 
     * @type {number}
     * @memberof ResponseOptions
     */
    txStyleRequestHeaderNewLinesAfterRequestContent?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponseOptions
     */
    txStyleRequestHeaderNewLinesAfterRequestHeader?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponseOptions
     */
    txStyleRequestNewLinesAfterInterrogatory?: number | null;
    /**
     * 
     * @type {ResponseStyleType}
     * @memberof ResponseOptions
     */
    responseStyleType?: ResponseStyleType;
}

export function ResponseOptionsFromJSON(json: any): ResponseOptions {
    return ResponseOptionsFromJSONTyped(json, false);
}

export function ResponseOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'txStyleRequestHeaderNewLinesAfterRequestContent': !exists(json, 'txStyleRequestHeaderNewLinesAfterRequestContent') ? undefined : json['txStyleRequestHeaderNewLinesAfterRequestContent'],
        'txStyleRequestHeaderNewLinesAfterRequestHeader': !exists(json, 'txStyleRequestHeaderNewLinesAfterRequestHeader') ? undefined : json['txStyleRequestHeaderNewLinesAfterRequestHeader'],
        'txStyleRequestNewLinesAfterInterrogatory': !exists(json, 'txStyleRequestNewLinesAfterInterrogatory') ? undefined : json['txStyleRequestNewLinesAfterInterrogatory'],
        'responseStyleType': !exists(json, 'responseStyleType') ? undefined : ResponseStyleTypeFromJSON(json['responseStyleType']),
    };
}

export function ResponseOptionsToJSON(value?: ResponseOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'txStyleRequestHeaderNewLinesAfterRequestContent': value.txStyleRequestHeaderNewLinesAfterRequestContent,
        'txStyleRequestHeaderNewLinesAfterRequestHeader': value.txStyleRequestHeaderNewLinesAfterRequestHeader,
        'txStyleRequestNewLinesAfterInterrogatory': value.txStyleRequestNewLinesAfterInterrogatory,
        'responseStyleType': ResponseStyleTypeToJSON(value.responseStyleType),
    };
}


